import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            companiesPayments: [],
            partnerCompanies: [],
            namesForPartner: LocService.t('label_name_for_partner'),
            customCategory: '',
            isEnableGender: false,
            hiddenColumns: CONFIG_COMPANY.HIDDEN_COLUMNS_USER_TABLE ,
            showUserAdditionalInfo: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO,
            showUserAdditionalInfoLessonUrl: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO_LESSON_URL,
            customCategories: [],
            role: '',
            userTypes: [],
            additionalInfo: {
                userInfo: null,
            },
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                role: 'ROLE_USER',
                username: '',
                paidDate: null,
                expireDate: null,
                birthday: null,
                shoesSize: null,
                userInfo: null,
                lessonUrl: null,
                restOfTraining: 0,
                isAcceptTerms: false,
                companyPayment: null,
                partnerCompany: null,
                customCategory: '',
                userType: null,
                gender: null,
                isMainAdmin: null,
            },
            showPartners: false
        }
    },
    methods: {
        update: update,
        clear: clear,
        loadSaradnici: loadSaradnici,
        deleteSaradnik: deleteSaradnik,
        loadCompanyPartner: loadCompanyPartner,
        seePayments: seePayments,
        resetPassword: resetPassword,
        loadUserInfo: loadUserInfo,
        formatBalanceAmount: formatBalanceAmount,
        getBalanceClass: getBalanceClass
    },
    beforeMount() {
        this.role = session.getRole();
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        let _self = this;
        this.id = this.$route.query.id;
        this.showPartners = session.getConfig().enablePartnersForRegister == null ? true : session.getConfig().enablePartnersForRegister
        this.customCategory = session.getConfig().customCategory == null ? '' : session.getConfig().customCategory
        if(session.getConfig().customCategories != null){
            this.customCategories = session.getConfig().customCategories.split(";")
        }
        if(CONFIG_COMPANY.USER_TYPES != null){
            this.userTypes = CONFIG_COMPANY.USER_TYPES;
        }
        this.isEnableGender = CONFIG_COMPANY.ENABLE_GENDER != null ? CONFIG_COMPANY.ENABLE_GENDER : false;

        this.loadSaradnici();
        this.loadCompanyPartner();
        AdminApiService.getUser(this.$route.query.id)
            .then((response) => {
                _self.model = response.data;
                _self.model.userInfo = "nesto";
                _self.model.paidDate = this.$moment(new Date(_self.model.paidDate * 1000)).format('YYYY-MM-DD')
                _self.model.expireDate = this.$moment(new Date(_self.model.expireDate * 1000)).format('YYYY-MM-DD')
                if(response.data.birthday != null){
                    _self.model.birthday = _self.$moment(new Date(response.data.birthday  * 1000)).format('YYYY-MM-DD')
                }

            })
            .catch(error => {

                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
        _self.loadUserInfo();

    }
}

function loadUserInfo(){
    if(this.showUserAdditionalInfo !== true) return;
    let _self = this;
    AdminApiService.getUserAdditionalInfo(this.$route.query.id)
        .then((response) => {
            if(response.data != null){
                _self.additionalInfo.userInfo = response.data.userInfo;
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function clear() {
    this.model.email = '';
    this.model.name = '';
    this.model.phone = '';
    this.model.surname = '';
    this.model.role = 'ROLE_USER';
    this.model.username = '';
    this.model.paidDate = null;
    this.model.expireDate = null;
    this.model.birthday = null;
    this.model.shoesSize = null;
    this.model.lessonUrl = null;
    this.model.userInfo = null;
    this.model.restOfTraining = 0;
    this.model.companyPayment= null;
    this.model.partnerCompany= null;
    this.model.customCategory= '';
    this.model.userType = null;
    this.model.gender = null;
    this.model.isMainAdmin = null;
}

function update() {
    this.model.paidDate = this.model.paidDate + 'T00:00:00.000Z';
    this.model.expireDate = this.model.expireDate + 'T00:00:00.000Z';
    this.model.userInfo = this.additionalInfo.userInfo;
    if(this.model.birthday != null){
        this.model.birthday = this.model.birthday + 'T08:00:00.000Z';
    }
    let id = this.id;
    AdminApiService.updateUser(this.model, id)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_user_edited'), 'success')
            this.$router.push('/users')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    let id = this.id;

    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_reset_password_to_user'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.resetUserPassword(id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_password_update'), 'success')
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function loadSaradnici() {
    let _self = this;

    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.companiesPayments = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })


}

function deleteSaradnik(){
    this.model.companyPayment = null;
}

function seePayments(){
    this.$router.push('/payment-user?id=' + this.id + '&name=' +  this.model.name + ' ' +  this.model.surname)
}

function formatBalanceAmount(amount){
    const value = parseFloat('' + (amount != null ? amount : 0));
    if(!Number.isFinite(value)) return '0.00';
    return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function getBalanceClass(amount){
    const value = parseFloat('' + (amount != null ? amount : 0));
    if(!Number.isFinite(value)) return 'is-neutral';
    if(value < 0) return 'is-negative';
    if(value > 0) return 'is-positive';
    return 'is-neutral';
}



// WEBPACK FOOTER //
// ./src/components/Users/Edit/EditUser.js